var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"content-editable",attrs:{"contenteditable":!_vm.disabled,"placeholder":_vm.placeholder},domProps:{"textContent":_vm._s(_vm.value)},on:{"blur":_vm.onInput,"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;$event.preventDefault();}}})
}
var staticRenderFns = []

export { render, staticRenderFns }